"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEq = setEq;

function setEq(a, b) {
  return Array.from(a).every(function (x) {
    return b.has(x);
  });
}